export enum MarketTypeVariant {
  STUDENT_HOUSING = 'student_housing',
  CO_LIVING = 'co_living',
}
